import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { AuthShell } from "@/features/auth/AuthShell";
import { authService } from "@/services/authService";
import { apiError } from "@/services/api";
import { Button, Input, Label } from "@/components";

export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error(t("resetPassword.mismatch")); return; }
    setLoading(true);
    try {
      await authService.resetPassword(token, password);
      toast.success(t("resetPassword.success"));
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title={t("resetPassword.title")} subtitle={t("resetPassword.subtitleInvalid")}>
        <p className="text-center text-sm text-muted-foreground" data-testid="reset-no-token">
          {t("resetPassword.noToken")} <Link to="/forgot-password" className="text-primary hover:underline">{t("resetPassword.requestNew")}</Link>.
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title={t("resetPassword.title")} subtitle={t("resetPassword.subtitleChoose")}>
      <form onSubmit={submit} className="flex flex-col gap-4" data-testid="reset-form">
        <div className="flex flex-col gap-2">
          <Label htmlFor="password">{t("resetPassword.newPassword")}</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder={t("resetPassword.newPasswordPlaceholder")} minLength={8} required data-testid="reset-password" />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="confirm">{t("resetPassword.confirm")}</Label>
          <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder={t("resetPassword.confirmPlaceholder")} minLength={8} required data-testid="reset-confirm" />
        </div>
        <Button type="submit" disabled={loading} data-testid="reset-submit">
          {loading ? t("resetPassword.submitting") : t("resetPassword.submit")}
        </Button>
      </form>
    </AuthShell>
  );
}
